import { render, staticRenderFns } from "./LoginTest.vue?vue&type=template&id=38dd9ef8&scoped=true&"
import script from "./LoginTest.vue?vue&type=script&lang=js&"
export * from "./LoginTest.vue?vue&type=script&lang=js&"
import style0 from "./LoginTest.vue?vue&type=style&index=0&id=38dd9ef8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dd9ef8",
  null
  
)

export default component.exports